import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function PhoneNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null; // Let required validator handle empty values
    }

    const phoneStripped = control.value
      .toString()
      .replace(/\s+/g, '')
      .replace(/[()-]/g, '');

    // E.164 international format: +[country code][national number]
    // Country codes: 1-3 digits, total length: 7-15 digits (including country code)
    const internationalPattern = /^\+[1-9]\d{1,14}$/;

    // Alternative formats without + (common in some countries)
    // National format with country code: [country code][national number]
    const nationalPattern = /^[1-9]\d{6,14}$/;

    // Check if it matches international format
    if (internationalPattern.test(phoneStripped)) {
      return null;
    }

    // Check if it matches national format
    if (nationalPattern.test(phoneStripped)) {
      return null;
    }

    // For backward compatibility, also check Philippines format
    const philippinesPattern = /^(09|639|\+639)\d{9}$/;
    if (philippinesPattern.test(phoneStripped)) {
      return null;
    }

    return { invalidPhoneNumber: true };
  };
}
